<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">Inventory need to be RE-ORDER 
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="7">
            <b-input-group >
                <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                <b-form-select
                  v-model="filter.kodeacc"
                  :plain="true"
                  :options="headCategories"
                ></b-form-select>
                <b-input-group-append><b-button class="btn btn-success ml-2" @click="getData()"> <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper mt-2">
        <table style="width: 100%;">
          <thead>
            <tr>
                <th width="300px" rowspan="2">Master Item </th>
                <th width="150px" rowspan="2">Category</th>
                <th width="80px" rowspan="2">Min. Qty.Stock</th>
                <th width="80px" rowspan="2">Max. Qty.Reorder</th>
                <th width="150px" rowspan="2">Last Vendor/Supplier </th>
                <th width="150px" rowspan="2">Last Price </th>
              <th colspan="2" style="text-align:center;">CURRENT STOCK BALANCE</th>
            </tr>
            <tr>
                <th width="80px">Qty Avail</th>
                <th width="80px">On Transfer</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="(row, index ) in detaildata" :key="index">
                  <td >{{row.partnumber}} | {{row.itemname}}</td>
                  <td>{{row.nmcategory}} </td>
                <td>{{row.reorderpoint | numFormat('0,0.00')}}</td>
                <td>{{row.reorderqty | numFormat('0,0.00')}}</td>
                <td>{{row.vendor}}</td>
                <td>{{row.lastprice | numFormat('0,0.00')}} {{row.lastpriceunit}}</td>
                  <td style="text-align:right">{{row.qtyAvail | numFormat('0,0.00')}} {{row.invunitom}}</td>
                  <td style="text-align:right">({{row.qtyTransfer | numFormat('0,0.00')}})</td>
              </tr>
            </tbody>
        </table>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>


<script>
// import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
import logistic_rpt from "../../apis/logistic_rpt";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  // mixins: [validationMixin],
  // validations: {
  //   filter: {
  //       tgl1: { required },
  //       tgl2: { required },
  //       headcategory:{ required },
  //   },
  // }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      filter: {kodeacc:'',headcategory:''},
      uanguser: this.$store.state.user.matauang,
      monthLabels:dropdown.monthLabels,
      smrydata : [],
      detaildata : [],
      subtotal : {posting : -1},
        headCategories:[],
        itemCategories:[]
    };
  },
  components: {VueMonthlyPicker,Loading},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
  watch:{
      "filter.kodeacc": function(newval) {
          this.filter.headcategory="";
          this.filter.headcategory=this.headCategories.find(d => d.value === newval).text;
      },
  },
  created: async function(){
        const [a,b] = await Promise.all([logistic_rpt.inventorygroup(),logistic_rpt.group()]) ;
        this.itemCategories = b; 
      this.headCategories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      this.getData();
  },  
  methods: {
    getData: async function() {
      //   if (this.invalidFilter) {
      //       toastr.error('Please fill the form correctly.');
      //  } else {
        this.isLoading=true;
        try {
          const result = await logistic_rpt.reorder(this.filter);
          // console.log('result',result)
          // this.smrydata =  result[0];
          this.detaildata = result[0];
        } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
        }
        this.isLoading=false;      
      //  }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await logistic_rpt.reorderexport(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
